import React, { useState } from 'react';
import PhilipsLogo from '../../../assets/images/logo.png';
import './header.css';
import { REACT_APP_CAD_CONSUMER_URL } from '../utils/constants';

function Header(props: any) {
  const { path } = props;
  const [isActive, setActive] = useState(false);

  const toggleClass = () => {
    setActive(!isActive);

    const body = document.querySelector('body');
    if (body) {
      body.classList.toggle('mobile-nav-active');
    }

    const navbar = document.getElementById('navbar');
    if (navbar) {
      navbar.classList.toggle('navbar-left');
    }
  };

  const isMobileDevice = () => {
    return /Mobi|Android/i.test(navigator.userAgent);
  };

  const handleSignInClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (!isMobileDevice()) {
      e.preventDefault();
      alert('Kindly use your mobile device to register or sign in.');
    }
  };

  return (
    <header id="header" className="header fixed-top" data-scrollto-offset="0">
      <div className="container-fluid d-flex align-items-center ">
        {/* Logo */}
        <a href="/" className="logo d-block align-items-center scrollto me-auto me-lg-0">
          <img src={PhilipsLogo} alt="Philips" className="img-fluid" />
        </a>

        {/* Navigation */}
        <nav id="navbar" className={`navbar mb-3 ${isActive ? 'navbar-left' : ''}`}>
          <ul id="myList" className="custom-ul d-flex align-items-start">
            {/* Home (scrolls) */}
            <li className="nav-link">
              <a className={path === '/' ? 'active scrollto' : 'scrollto'} href="/">
                <span>Home</span>
              </a>
            </li>

            {/* Services (scrolls) */}
            <li className="nav-link">
              <a className={path === '/services' ? 'active scrollto' : 'scrollto'} href="/services">
                <span>Services</span>
              </a>
            </li>
            <li className="nav-link">
              <button
                type="button"
                className={path === '/hqi' ? 'active scrollto' : 'scrollto'}
                onClick={() => (window.location.href = '/hqi')}
              >
                <span>HQI</span>
              </button>
            </li>
            {/* Mobile nav toggle */}
            <button
              type="button"
              onClick={toggleClass}
              className={isActive ? 'bi mobile-nav-toggle bi-x' : 'bi mobile-nav-toggle bi-list d-none'}
              aria-label="Toggle navigation"
              tabIndex={0}
            ></button>
          </ul>
        </nav>

        {/* Sign In */}
        <a
          className="btn-getstarted scrollto"
          target="_self"
          href={REACT_APP_CAD_CONSUMER_URL}
          onClick={handleSignInClick}
        >
          Sign In
        </a>
      </div>
    </header>
  );
}

export default Header;
